import { usePrivateBinsDialog } from '@utils/dialogs-hooks';
import { useTranslation, Trans } from 'react-i18next';

export default function PrivateBins() {
  const { t } = useTranslation();
  const { openPrivateBinsDialog } = usePrivateBinsDialog();

  return (
    <div className="offer__block bins">
      <div className="offer__content">
        <p className="title-h3m">{t('looking_for_private_bins')}</p>
        <Trans
          i18nKey="looking_for_private_bins_text"
          components={{ span: <span className="fw-500" /> }}
        />
        <button className="dashed-btn" onClick={openPrivateBinsDialog}>
          {t('request_private_bin')}
        </button>
      </div>
    </div>
  );
}
